import { render, staticRenderFns } from "./JumpSellerListOrders.vue?vue&type=template&id=172c8c7c&scoped=true&"
import script from "./JumpSellerListOrders.vue?vue&type=script&lang=js&"
export * from "./JumpSellerListOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172c8c7c",
  null
  
)

export default component.exports